export function sumAmountsInCents<T>(
  rows: T[],
  selector: (row: T) => number,
): number {
  const totalCents = rows.reduce(
    (acc, row) => acc + Math.round(selector(row) * 100),
    0,
  );
  return totalCents / 100;
}
